const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const AT = require("../vault/ActionTypes");
const withVaultDispatch = require("../hoc/withVaultDispatch");
const Copy = require("../util/CopyTable");
const URLMake = require("../../../shared/URLMake");

const styles = require("./styles/ProtectedView.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "ProtectedView",

		propTypes: {
			user: PT.object,
			type: PT.oneOf(["notLoggedIn", "badPermissions"]).isRequired,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		openModal: function(type) {
			if (type === "notLoggedIn") {
				this.startLogin();
			}
		},

		startLogin: function() {
			if (global.window) {
				window.location.href = URLMake.forLogin();
			}
		},

		switchAccounts: function() {
			this.props.dispatch({
				type: AT.LOGOUT_USER_REQUEST,
				forSwitch: true,
			});
		},

		render: function() {
			const {type, user} = this.props;
			const message = Copy.getProtectedViewCopy(user)[type];

			const clickAction =
				type === "notLoggedIn"
					? () => this.openModal(type)
					: this.switchAccounts;

			return (
				<div className={styles.main}>
					{message}
					<div onClick={clickAction} className={styles.button}>
						{type === "notLoggedIn" ? "sign in" : "switch accounts"}
					</div>
				</div>
			);
		},
	})
);
